import { type InsuranceCorporateIdentity } from "../types";

export function KonigUndBauerLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M240.637 408.643C283.363 408.643 318.549 374.805 318.549 334.701V234.442H404V274.545H361.274V334.701C361.274 398.617 307.239 450 240.637 450C174.035 450 120 398.617 120 334.701C120 295.851 140.106 259.507 174.035 238.201C175.292 236.948 182.832 233.188 182.832 233.188C182.832 233.188 181.575 231.935 179.062 230.682C179.062 230.682 175.292 228.175 174.035 226.922C155.186 209.377 143.876 185.565 142.619 160.5V155.487C143.876 105.357 189.115 64 241.894 64C297.186 64 341.168 106.61 341.168 157.994V159.247H298.443V157.994C298.443 129.169 273.31 105.357 241.894 105.357C210.478 105.357 185.345 129.169 185.345 157.994C185.345 180.552 200.425 201.857 221.788 209.377C234.354 215.643 246.92 215.643 255.717 215.643V257H239.381C197.912 257 162.726 294.597 162.726 334.701C162.726 376.058 197.911 408.643 240.637 408.643Z"
        fill="white"
      />
    </svg>
  );
}

export const KonigUndBauer: InsuranceCorporateIdentity = {
  id: "konig-und-bauer",
  name: "König und Bauer",
  logo: KonigUndBauerLogo,
  backgroundColor: "#243C71",
  textColor: "#FFFFFF",
  wildcard: { or: [{ and: ["könig", "bauer"] }, "koenig"] },
  type: "statutory",
};
